"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CircleAlert } from "lucide-react";
function PostsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="86098" className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div data-index={i} key={i} className="flex flex-col gap-4">
            <div className="aspect-video w-full animate-pulse rounded-[2px] bg-muted/50" />
            <div className="h-6 w-24 animate-pulse rounded-[2px] bg-muted/50" />
            <div className="h-8 w-full animate-pulse rounded-[2px] bg-muted/50" />
            <div className="h-8 w-2/3 animate-pulse rounded-[2px] bg-muted/50" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center rounded-[2px] border border-destructive/20 bg-destructive/5 p-8 text-center">
        <CircleAlert className="mb-4 size-8 text-destructive" />
        <p className="text-sm text-destructive font-default">Failed to load insights. Please try again later.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="flex flex-col items-center justify-center rounded-[2px] border border-border border-dashed p-12 text-center">
        <p className="text-muted-foreground font-default">No insights published yet. Check back soon.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {posts.map((post, i) => <div data-index={i} key={post.id} className="h-full">
          <Link to={post.link || "#"} className="group block h-full">
            <Card className="h-full overflow-hidden border-transparent bg-transparent shadow-none transition-all duration-300 hover:bg-card hover:shadow-md rounded-[2px]">
              <div className="relative aspect-video w-full overflow-hidden rounded-[2px]">
                <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633756/img/generic_blog_placeholder.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <CardContent className="px-0 py-6 group-hover:px-6">
                {post.categories && post.categories.length > 0 && <Badge variant="secondary" className="mb-4 bg-[#F0FAFF] text-[#28AADE] border-none rounded-[2px] font-default font-semibold">
                    {post.categories[0].name}
                  </Badge>}
                <h3 className="font-default text-[14px] font-bold leading-tight text-[#222222] transition-colors duration-300 group-hover:text-[#007EB0]">
                  {post.title}
                </h3>
              </CardContent>
            </Card>
          </Link>
        </div>)}
    </div>;
}
export default function InsightsAndInnovation() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query({
    post_type: "post",
    ...wp_query_params
  });
  return <section id="insights-from-the-frontier" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="mb-4 font-default text-3xl font-bold tracking-tight text-[#222222] md:text-4xl lg:text-5xl">
              Insights from the Frontier
            </h2>
            <p className="text-sm leading-relaxed text-muted-foreground font-default">
              Deep dives into AI strategy, automation trends, and the future of enterprise intelligence for small and medium businesses.
            </p>
          </div>
          <Link to="#" className="inline-flex items-center justify-center whitespace-nowrap rounded-[2px] text-sm font-bold text-[#007EB0] underline-offset-4 transition-colors hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28AADE] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 font-default">
            View all insights &rarr;
          </Link>
        </div>

        <PostsProvider wp_query={wp_query}>
          <PostsConsumer />
        </PostsProvider>
      </div>
    </section>;
}